window.$ = require("jquery")
window.jQuery = require("jquery")
import "kendo/kendo.all.js"
import "kendo/cultures/kendo.culture.sv-SE.js"
import "kendo/kendo.aspnetmvc.js" 